/**
 * 发送指令
 * Created by bxtang on 2017/3/20.
 */
import React, {useEffect, useRef, useState} from "react"
import {Button, DatePicker, Form, Input, message, Radio, Select} from "antd"
import {WWUtils,WWMethods} from "@/tools";
import DirectiveItems from "./DirectiveItems"
import moment from "moment/moment";
let formatTime = 'YYYY-MM-DD HH:mm:ss'
const FormItem = Form.Item;
const itemLayout = {
    labelCol: {span: 2},
    wrapperCol: {span: 8},
};
const itemLayoutWithOutLabel = {
    wrapperCol: {span: 2},
}
const itemLayoutLabel = {
    wrapperCol: {span:8,offset:2},
}
const interval_arr = [];
const hasSuccess = [];

function getInstructionFeedback(historyId) {
    if (!hasSuccess[historyId]) {
        WWMethods.checkDirectiveStatus(historyId,(data)=>{
            if (data.status != 0) {
                hasSuccess[historyId] = true;
            }
            if (xhr.status == 504) {
                message.error(Strings.timeout || "介面逾时，请稍后再试");
            }
        })
    }
}

function SendDirective(props, ref) {
    const [instruction, setInstruction] = useState({})
    const [directiveList, setDirectiveList] = useState([])
    const [loading, setLoading] = useState(false)
    const [isOnline, setIsOnline] = useState(false)
    const [password, setPassword] = useState(null)
    const [sendDirStatus, setSendDirStatus] = useState(false)
    const [valType, setValType] = useState('text')
    const [sendType,setSendType] = useState("")
    const [deadlineTime,setDeadlineTime] = useState("")
    const formRef = useRef(null)
    const directive = useRef(null)

    useEffect(() => {
        setSendDirStatus(false)
        if (props.instruction) {
            setInstruction(props.instruction)
        }
        if (interval_arr.length) {
            interval_arr.forEach(function (item) {
                if (item) {
                    clearInterval(item);
                }
            })
        }
        setSendType("")
        setDeadlineTime("")
    }, [props.instruction])
    useEffect(() => {
        // if(props.directiveList) {
        setSendDirStatus(false)
        setDirectiveList(props.directiveList)
        // }
    }, [props.directiveList])
    useEffect(() => {
        if (props.isOnline) {
            setIsOnline(props.isOnline)
        }
    }, [props.isOnline])


    /**
     * 指令下发
     * @param {*} e
     * @returns
     */

    function sendDirective(e) {
        const model = arrangeDirectiveParams();
        if (!model) {
            return;
        }

        setLoading(true)
        const that = this;
        if (props.refreshDirectiveList instanceof Function) {
            props.refreshDirectiveList();
        }
        if (interval_arr.length) {
            interval_arr.forEach(function (item) {
                if (item) {
                    clearInterval(item);
                }
            })
        }
        WWMethods.sendDirective(model,(data)=>{
            if (data.code == 0) {
                setSendDirStatus(true)
                setLoading(false)
                if (data.historyId && isOnline) {
                    hasSuccess[data.historyId] = false;
                    getInstructionFeedback(data.historyId);
                    if (Boolean(hasSuccess[data.historyId])) {
                        return false;
                    }
                    const interval = setInterval(function () {
                        getInstructionFeedback(data.historyId);
                        if (Boolean(hasSuccess[data.historyId])) {
                            clearInterval(interval);
                            interval_arr.splice(interval, 1);
                            delete hasSuccess[data.historyId];
                            setLoading(false)
                        }
                    }, 5000)
                    interval_arr.push(interval)
                } else {
                    setLoading(false)
                }
            } else {
                setLoading(false)
                message.error(data.message);
            }
        })

    }
    function getOptionsFromGlobalEnums(key,type){
        let globalEnums = JSON.parse(localStorage.getItem("globalEnums"));
        if(globalEnums && globalEnums[key]){
            if(type === "select"){//下拉框
                return globalEnums[key].map((item)=>{
                    return <Option key={item.code} value={item.code}>{item.name}</Option>
                })
            }else if(type === "radio"){
                return globalEnums[key].map((item)=>{
                    return <Radio key={item.code} value={item.code} title={item.name}>
                        {item.value ?<img src={item.value} title={item.name}></img>:null}
                    </Radio>
                })
            }else if(type === "checkbox"){
                /*  return globalEnums[key].map((item)=>{
                      return <Option key={item.code} value={item.code}>{item.name}</Option>
                  })*/
            }else{
                return globalEnums[key]
            }

        }else{
            return null;
        }
    }
    function handleDisabledBeforeDate(time){
        if (!time) {
            return false;
        } else {
            return (moment().valueOf() > (time.valueOf()+86399999));
        }
    }
    function arrangeDirectiveParams() {
        let paramsList = [];
        directive.current && directive.current.state.beanList.map(function (item) {
            if (item) {
                paramsList.push(item)
            }
        })
        let model = {
            param: {
                beanList: paramsList
            }
        }
        const that = this;
        const beanList = [];
        if (model.param) {
            model.param.beanList.forEach(function (item, index) {
                if (instruction.name != "打开星期模式" && instruction.name != "On week mode") {
                    if (item.timeValue && item.type !== "hour:min") {
                        console.log(moment(item.timeValue._d ? item.timeValue._d : item.timeValue).format('hhmm'));
                        item.value = moment(item.timeValue._d ? item.timeValue._d : item.timeValue).format('hhmm');
                        console.log(item.value)
                        delete item.timeValue;
                    } else if (item.timeValue && item.type === "hour:min") {
                        console.log(moment(item.timeValue._d ? item.timeValue._d : item.timeValue).format('hh:mm'));
                        item.value = moment(item.timeValue._d ? item.timeValue._d : item.timeValue).format('hh:mm');
                        console.log(item.value)
                        delete item.timeValue;
                    }
                    if (item.type === "hourAndMin" || item.type === "hour:min") {
                        delete item.type;
                    }
                }
                if (item.selectValue) {
                    item.value = item.selectValue;
                    delete item.selectValue;
                }
                if (item.inputValue) {
                    item.value = item.inputValue;
                    delete item.inputValue;
                }
                if (item.checkedValue != undefined) {
                    if (instruction.name != "打开星期模式" && tinstruction.name != "On week mode") {
                        if (item.checkedValue) {
                            item.value = item.formatValue;
                        } else {
                            item.value = "";
                        }
                        delete item.checkedValue;
                        delete item.formatValue;
                    }
                }
                if (item.intValue) {
                    item.value = parseInt(item.intValue);
                    delete item.intValue;
                }
            })
        }
        if (instruction.type == 2) {
            let password1;
            console.log(password)
            if (password){
                password1 = hex_md5(password)
            }else {
                password1 =password
            }
            model.param = {
                beanList: [{value: password1}],
            }
            if(sendType){
                model.sendType = sendType
            }
            if(deadlineTime){
                model.deadlineTime = moment(deadlineTime).unix();
            }else{
                if(sendType && (sendType === "1")){//下发方式为直到执行成功时，校验完成时间必须填写
                    message.error(Strings.deadlineTime)
                    return false;
                }
            }
        }
        if (instruction.name == "打开星期模式" || instruction.name == "On week mode") {
            let hasChoose = false;
            let checkboxValue = "";
            let timeValue = "";
            model.param.beanList.forEach(function (item) {
                if (item.checkedValue) {
                    hasChoose = true
                    checkboxValue += item.formatValue;
                }
                if (item.timeValue) {
                    if (item.type == "hour:min") {
                        timeValue = moment(item.timeValue._d).format('hh:mm');
                    } else if (item.type == "hourAndMin") {
                        timeValue = moment(item.timeValue._d).format('hhmm');
                    }
                }
            })
            if (!hasChoose) {
                message.error(Strings.rs10361);
                return false;
            }
            delete model.param;
            model.param = {
                beanList: [{
                    value: checkboxValue,
                }, {
                    value: timeValue,
                }],
            }
        }
        if (instruction.type == 4) {
            let password1;
            if(password){
                password1 = hex_md5(password);
            }else {
                password1 = password
            }
            model.param.beanList[1]={value: password1}
        }
        model.instructionId = instruction.instructionId;
        model.imei = instruction.imei;
        props.platform && props.platform === "mic"?model.sendPlatform = 1 : model.platformType = 1;
        return model;
    }

    const [form] = Form.useForm();
    const {
        getFieldDecorator, getFieldValue, resetFields,
    } = form;
    const displayStyle = {
        display: "none",
    }
    if (props.showDirective) {
        displayStyle.display = "block"
    }
    const that = this;
    let directiveItems;
    let micOnlyDirectiveExeItems;

    let passwordInput = <div>
        <Input style={{
            height: '0px',
            width: '0px',
            overflow: 'hidden',
            padding: '0px',
            border: 'none',
            position: 'absolute'
        }} maxLength={11}/>
        <FormItem
            label={Strings.password || "密码"}
            {...itemLayout}
            style={{marginBottom: 0}}
        >
            <Input autoComplete='new-password'
                onChange={(e) => setPassword(e.target.value)}
                style={{width: 200}}
                onClick={() => setValType('password')}
                type={valType}
                value={password}
            />
        </FormItem>
        <FormItem
            label={null}
            {...itemLayoutLabel}
        >
            <span style={{color:'#888888'}}> {Strings.confirmPwd || "发出指令前请重新确认密码"}</span>
        </FormItem>
    </div>

    let micExeItem =<div>
        <FormItem
            {...itemLayout}
            label={Strings.sendtype || "下发方式"}
            style={{ marginTop: 10,marginBottom: 10 }}
        >
            <Select
                value={sendType} placeholder={Strings.sendtypeTips}
                style={{ width: 200 }}
                onChange={(value)=>{
                    setSendType(value)
                }}>
                {getOptionsFromGlobalEnums("enums.cmdSendType","select")}
            </Select>
        </FormItem>
        <FormItem
            {...itemLayout}
            label={<span>{sendType === "1"?<span style={{color: 'red'}}>*</span>:""}{Strings.rs10277 || "结束时间"}</span>}
            style={{ marginTop: 10,marginBottom: 10 }}
        >
            <DatePicker value={deadlineTime ? moment(deadlineTime, formatTime) : null}
                        style={{width:200}}
                        format={formatTime} allowClear={true}
                        placeholder={Strings.rs14337}
                        className="calendar"
                        onChange={setDeadlineTime}
                        showToday={false}
                        showTime={true}
                        disabledDate={handleDisabledBeforeDate}/>
        </FormItem>
    </div>  ;
    if (directiveList) {
        directiveItems = <div>
            <DirectiveItems ref={directive}
                            directiveList={directiveList} resetFields={resetFields}
                            getFieldDecorator={getFieldDecorator}/>
          {/*自定义指令*/}
            {instruction.type == 4? passwordInput:null}
        </div>
    }
    if (instruction.type == 2) {//控制指令
        directiveItems = passwordInput
        if(props.platform === "mic"){
            micOnlyDirectiveExeItems = micExeItem;
        }
    }
    let tipContent;
    if (instruction.instructionId == 19 || instruction.instructionId == 20) {
        tipContent = (
            <div className="total_tip mg_bottom24 mg_top0">
                {Strings.sendTips || "在发送命令以切断或恢复油/电之前，必须先设置中心编号。 设备将仅接受中心号码发出的“切断油/电”命令。 中心号码可以是任何手机号码，但必须由具有先前设置的SOS号码的电话设置"}
            </div>
        )
    } else if (instruction.instructionId == 18 || instruction.instructionId == 17) {
        tipContent = (
            <div className="total_tip mgb24 mgt0">
                {Strings.sendTips1 || "紧急情况下，请按住SOS按钮3秒钟，以生成SOS警报。设备终端将向输入的SOS号码分别发送一条位置消息，并一一呼叫SOS号码(如果无人接听，最多呼叫3次)"}
            </div>
        )
    } else {
        tipContent = WWUtils.isNull(instruction.description) ? "" : (
            <div className="total_tip mg_bottom24 mg_top0">
                {instruction.description}
            </div>
        )
    }
    let loadingDiv;
    if (loading) {
        loadingDiv = (
            <span>
         {/* <LoadingOutlined/>*/}
                &nbsp;&nbsp;&nbsp;&nbsp;
                {Strings.sendTips2 || "发送命令，需要等待回复或检查命令记录"}
        </span>
        )
    }

    return (
        <div style={displayStyle}>
            {tipContent}
            <Form ref={formRef} name="control-ref"
                  onFinish={sendDirective}
            >
                <FormItem
                    label={Strings.cmd || "指令"}
                    {...itemLayout}
                    style={{marginBottom: 11}}
                >
                    {instruction.name}
                </FormItem>
                <FormItem
                    label={Strings.imei || "设备号"}
                    {...itemLayout}
                    style={{marginBottom: 11}}
                >
                    {instruction.imei}
                </FormItem>
               {/*机械智控特有的下发方式和结束时间*/}
                {props.platform === "mic"?micOnlyDirectiveExeItems:null}
                {directiveItems}
                {!sendDirStatus ? (
                    WWUtils.checkPermission("2-2-6-1") ? (
                        <FormItem
                            {...itemLayoutWithOutLabel}
                            style={{marginBottom: 11,textAlign:"left"}}
                        >
                            <Button className="mg_top24 gps_button_s mgl0 mgt15" type="primary"
                                    htmlType="submit">{Strings.send || "发送"}</Button>
                        </FormItem>
                    ) : null
                ) : (
                    <FormItem
                        label={Strings.sendResult || "发送结果"}
                        {...itemLayout}
                        style={{marginTop: 11}}
                    >
                        {Strings.sendSuccess || "指令发送成功"}
                    </FormItem>
                )}
                {loadingDiv?<FormItem
                    {...itemLayoutWithOutLabel}
                    style={{marginTop: 11}}
                >
                    {loadingDiv}
                </FormItem>:null}

            </Form>

        </div>
    )

}
export default SendDirective
